import HttpService from "./htttp.service";

class CallsService {
  getCalls = async (page, pageSize, sortColumn, sortColumnValue, searchValue) => {
    let fetchUrl = "calls";
    if (page && pageSize && sortColumn && sortColumnValue) {
      fetchUrl = `calls?page=${page}&per_page=${pageSize}&sort_column=${
        sortColumn
      }&sort_column_value=${sortColumnValue}&search_value=${encodeURIComponent(searchValue)}`;
    }
    return await HttpService.get(fetchUrl);
  };

  showCall = async (id) => {
    const fetchUrl = `calls/${id}`;
    return await HttpService.get(fetchUrl);
  };
}

export default new CallsService();
